<template>
	<div class="layout-footer">
        <p>Minden jog fenntartva © 2024 Belvárosi Közösségi Tér.</p>
	</div>
</template>

<script>
	export default {
		name: "AppFooter",
		methods: {
		},
		computed: {
			darkTheme() {
				return this.$appState.darkTheme;
			}
		}
	}
</script>